import { render, staticRenderFns } from "./Text2Speech.vue?vue&type=template&id=b8e7f766"
import script from "./Text2Speech.vue?vue&type=script&lang=ts&setup=true"
export * from "./Text2Speech.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Text2Speech.vue?vue&type=style&index=0&id=b8e7f766&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1__ejs@3.1._d122e8da27108b932c0dfa09e6e9a5ee/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports